import React from 'react';
import { Link } from 'react-router-dom';
import './ProjectCard.css';

const ProjectCard = ({
  title,
  description,
  image,
  tags = [],
  link,
  externalLink
}) => {
  const CardWrapper = ({ children }) => {
    if (link) {
      return <Link to={link} className="project-card">{children}</Link>;
    }
    if (externalLink) {
      return <a href={externalLink} target="_blank" rel="noopener noreferrer" className="project-card">{children}</a>;
    }
    return <div className="project-card">{children}</div>;
  };

  return (
    <CardWrapper>
      <div className="project-card-image">
        <img src={image} alt={title} loading="lazy" />
      </div>
      <div className="project-card-overlay">
        <div className="project-card-content">
          <h3 className="project-card-title">{title}</h3>
          <p className="project-card-desc">{description}</p>
          {tags.length > 0 && (
            <div className="project-card-tags">
              {tags.map((tag, index) => (
                <span key={index} className="project-card-tag">{tag}</span>
              ))}
            </div>
          )}
        </div>
      </div>
    </CardWrapper>
  );
};

export default ProjectCard;
